export default {"src":"/_next/static/media/logo-coupang.ea9b461a.svg","height":120,"width":168,"blurWidth":0,"blurHeight":0};